// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"styles_toggleWrapper__sRDVy","mobileToggle":"styles_mobileToggle__dsg9e"};